var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%" },
      attrs: { border: "", data: _vm.tableData, height: "600px" },
    },
    [
      _c("el-table-column", {
        attrs: { prop: "id", label: "ID", width: "180" },
      }),
      _c("el-table-column", {
        attrs: { prop: "mediaAssetId", label: "乐播媒资ID", width: "180" },
      }),
      _c("el-table-column", {
        attrs: {
          "show-overflow-tooltip": "",
          prop: "title",
          label: "内容标题",
        },
      }),
      _c("el-table-column", {
        attrs: { prop: "coverImg", label: "内容图片", width: "150" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("el-image", {
                  staticStyle: { height: "50px" },
                  attrs: {
                    src: scope.row.coverImg,
                    "preview-src-list": [scope.row.coverImg],
                    fit: "scale-down",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.clickImg.apply(null, arguments)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { prop: "partnerName", label: "媒资来源" },
      }),
      _c("el-table-column", { attrs: { prop: "tags", label: "宣传标签" } }),
      _c("el-table-column", {
        attrs: { prop: "status", label: "状态" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                scope.row.status === 0
                  ? _c("span", [_vm._v("下架")])
                  : scope.row.status === 1
                  ? _c("span", [_vm._v("上架")])
                  : scope.row.status === 2
                  ? _c("span", [_vm._v("待上架")])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { prop: "createTime", label: "创建时间" },
      }),
      _c("el-table-column", {
        attrs: { prop: "effectStartTime", label: "上架时间" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                scope.row.status !== 0 &&
                scope.row.effectStartTime &&
                scope.row.effectEndTime
                  ? _c("span", [
                      _vm._v(
                        _vm._s(scope.row.effectStartTime) +
                          " 至 " +
                          _vm._s(scope.row.effectEndTime)
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", { attrs: { prop: "remark", label: "备注" } }),
      _c("el-table-column", {
        attrs: { fixed: "right", label: "操作", width: "120" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "LIST_CONTENT_MANAGE_LOG",
                        expression: "'LIST_CONTENT_MANAGE_LOG'",
                      },
                    ],
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.viewLog(scope.row)
                      },
                    },
                  },
                  [_vm._v("日志")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "LIST_CONTENT_MANAGE_EDIT",
                        expression: "'LIST_CONTENT_MANAGE_EDIT'",
                      },
                    ],
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.edit(scope.row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "LIST_CONTENT_MANAGE_DEL",
                        expression: "'LIST_CONTENT_MANAGE_DEL'",
                      },
                    ],
                    attrs: { type: "text", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.del(scope.row)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }